export default "__VITE_ASSET__Cflp7WrE__"